module.exports = __webpack_public_path__ + "hp.png?c28b828cde7c89a7ea73494e697c1eb7";